// Mock data for Capitara Financial Recovery Company

export const companyInfo = {
  name: 'Capitara',
  tagline: 'Возвращаем ваши средства. Профессионально и надёжно.',
  description: 'Capitara — ведущая финансовая компания, специализирующаяся на возврате средств через банковские процедуры от мошенников, недобросовестных брокеров и инвестиционных пирамид. Наша команда экспертов с 15-летним опытом успешно возвращает деньги клиентам по всему миру.',
  mission: 'Наша миссия — защитить права инвесторов и вернуть то, что принадлежит им по праву. Мы используем банковские процедуры и работу с финансовыми регуляторами для достижения результата.',
  email: 'CapitaraFinancial@gmail.com',
  telegram: '@Capitara'
};

export const services = [
  {
    id: 1,
    title: 'Возврат средств от брокеров',
    description: 'Возврат депозитов от нелицензированных и недобросовестных форекс и криптовалютных брокеров',
    icon: 'TrendingUp',
    features: ['Анализ брокера', 'Банковское сопровождение', 'Международные запросы', 'Возврат до 95%']
  },
  {
    id: 2,
    title: 'Борьба с криптомошенниками',
    description: 'Возврат средств, похищенных через поддельные криптовалютные платформы и пирамиды',
    icon: 'Shield',
    features: ['Blockchain-анализ', 'Трассировка активов', 'Финансовая экспертиза', 'Возврат криптовалюты']
  },
  {
    id: 3,
    title: 'Инвестиционные споры',
    description: 'Разрешение споров с инвестиционными фондами и управляющими компаниями',
    icon: 'Scale',
    features: ['Аудит инвестиций', 'Работа с регуляторами', 'Банковское урегулирование', 'Компенсация убытков']
  },
  {
    id: 4,
    title: 'Возврат из финансовых пирамид',
    description: 'Помощь жертвам финансовых пирамид и MLM-схем в возврате вложенных средств',
    icon: 'AlertTriangle',
    features: ['Идентификация схемы', 'Коллективные претензии', 'Работа с регуляторами', 'Максимальная компенсация']
  }
];

export const processSteps = [
  {
    step: '01',
    title: 'Бесплатная консультация',
    description: 'Свяжитесь с нами через Telegram или форму обратной связи. Мы проанализируем вашу ситуацию и оценим шансы на возврат средств.',
    image: 'https://images.unsplash.com/photo-1562564055-71e051d33c19?w=600&q=80'
  },
  {
    step: '02',
    title: 'Финансовый анализ',
    description: 'Наши эксперты проведут полный анализ документов, транзакций и оснований для возврата средств через банковские процедуры.',
    image: 'https://images.unsplash.com/photo-1659355894099-b2c2b2884322?w=600&q=80'
  },
  {
    step: '03',
    title: 'План действий',
    description: 'Разработаем индивидуальную стратегию возврата с указанием сроков, этапов и прогнозируемого результата.',
    image: 'https://images.unsplash.com/photo-1765438869297-6fa4b627906a?w=600&q=80'
  },
  {
    step: '04',
    title: 'Реализация и возврат',
    description: 'Выполним все необходимые действия: от претензий в банки до международных запросов и работы с финансовыми регуляторами.',
    image: 'https://images.unsplash.com/photo-1617203443952-6d2619f7ff4e?w=600&q=80'
  }
];

export const advantages = [
  {
    title: 'Успешность 87%',
    description: 'Возвращаем средства в 87% случаев благодаря глобальной экспертизе',
    icon: 'Target'
  },
  {
    title: '15+ лет опыта',
    description: 'Работаем с 2010 года в сфере международных финансовых споров',
    icon: 'Award'
  },
  {
    title: 'Присутствие в 80+ странах',
    description: 'Работаем на всех континентах: Европа, Азия, Америка, Африка, Ближний Восток',
    icon: 'Globe'
  },
  {
    title: 'Оплата за результат',
    description: 'Комиссия только при успешном возврате средств',
    icon: 'CheckCircle'
  },
  {
    title: 'Конфиденциальность',
    description: 'Полная защита ваших данных и анонимность по международным стандартам',
    icon: 'Lock'
  },
  {
    title: 'Мультикультурная команда',
    description: '50+ специалистов по банковским процедурам и финансовых аналитиков из разных стран мира',
    icon: 'Users'
  }
];

export const stats = [
  {
    value: '$10.4M+',
    label: 'Возвращено клиентам',
    currency: '$'
  },
  {
    value: '2000+',
    label: 'Успешных кейсов'
  },
  {
    value: '80+',
    label: 'Стран мира'
  },
  {
    value: '24/7',
    label: 'Поддержка клиентов'
  }
];

export const testimonials = [
  {
    id: 1,
    name: 'Александр М.',
    text: 'Capitara помогла вернуть $45,000 от форекс-брокера мошенника. Процесс занял 4 месяца, но результат превзошел ожидания.',
    amount: '$45,000',
    date: 'Февраль 2024'
  },
  {
    id: 2,
    name: 'Елена К.',
    text: 'Потеряла деньги в криптопирамиде. Команда Capitara вернула 70% от суммы. Огромное спасибо за профессионализм!',
    amount: '€32,000',
    date: 'Январь 2024'
  },
  {
    id: 3,
    name: 'Дмитрий В.',
    text: 'Отличная работа! Вернули средства из нелицензированного фонда за 3 месяца. Рекомендую всем, кто столкнулся с мошенниками.',
    amount: '$28,500',
    date: 'Декабрь 2023'
  },
  {
    id: 4,
    name: 'Жамшид Н.',
    text: 'Forex brokerdan $23,000 qaytarib olishda yordam berishdi. Professional jamoa, juda minnatdorman!',
    amount: '$23,000',
    date: 'Март 2024',
    lang: 'uz'
  },
  {
    id: 5,
    name: 'Азиза Х.',
    text: 'Kriptovalyuta firibgarligidan zararlangan edim. Capitara 5 oy ichida pulimning 80% ini qaytarib berdi. Ishonchli kompaniya!',
    amount: '$18,500',
    date: 'Февраль 2024',
    lang: 'uz'
  },
  {
    id: 6,
    name: 'Фарход А.',
    text: 'Nolitsenzion investitsiya fondi bilan muammo bor edi. 3 oyda pulni to\'liq qaytarishdi. Rahmat!',
    amount: '$31,000',
    date: 'Январь 2024',
    lang: 'uz'
  },
  {
    id: 7,
    name: 'Нурбек С.',
    text: 'Forex брокердин $27,000 кайтарып алууда жардам беришти. Профессионалдуу командага ыраазымын!',
    amount: '$27,000',
    date: 'Март 2024',
    lang: 'ky'
  },
  {
    id: 8,
    name: 'Айгуль Т.',
    text: 'Криптовалюта алдамчылыгынан улам чыгымга учурадым. Capitara 4 айда акчамдын 75% кайтарып берди. Ишенимдүү компания!',
    amount: '€22,000',
    date: 'Февраль 2024',
    lang: 'ky'
  },
  {
    id: 9,
    name: 'Бакыт М.',
    text: 'Инвестициялык пирамида менен көйгөй болгон. Capitara 6 айда акчанын баарын кайтарууга жардам берди. Рахмат!',
    amount: '$35,000',
    date: 'Декабрь 2023',
    lang: 'ky'
  },
  {
    id: 10,
    name: 'محمد العلي',
    text: 'ساعدتني Capitara في استرداد 50,000$ من وسيط فوركس احتيالي. عملية احترافية وسريعة. شكراً جزيلاً!',
    amount: '$50,000',
    date: 'مارس 2024',
    lang: 'ar'
  },
  {
    id: 11,
    name: 'فاطمة خالد',
    text: 'خسرت أموالي في هرم استثماري. فريق Capitara استرد 80% من المبلغ في 5 أشهر. شركة موثوقة جداً!',
    amount: '€42,000',
    date: 'فبراير 2024',
    lang: 'ar'
  },
  {
    id: 12,
    name: 'أحمد حسن',
    text: 'تعاملت مع صندوق استثماري غير مرخص. Capitara استرد كامل المبلغ في 4 أشهر. ممتن للخدمة الممتازة!',
    amount: '$38,000',
    date: 'يناير 2024',
    lang: 'ar'
  }
];

export const faqData = [
  {
    question: 'Какова вероятность возврата средств?',
    answer: 'Вероятность зависит от конкретной ситуации. В среднем мы успешно возвращаем средства в 87% случаев. После бесплатной консультации мы сможем дать точную оценку ваших шансов.'
  },
  {
    question: 'Сколько времени занимает процесс возврата?',
    answer: 'Сроки варьируются от 1 недели до 1 месяца в зависимости от сложности дела, банковской системы страны и готовности банка к сотрудничеству. Мы всегда информируем о прогрессе на каждом этапе.'
  },
  {
    question: 'Какие документы необходимы для начала работы?',
    answer: 'Для оценки ситуации нужны: договоры с брокером/компанией, подтверждения транзакций, переписка, скриншоты платформы. Мы поможем собрать все необходимые доказательства.'
  },
  {
    question: 'Как формируется стоимость услуг?',
    answer: 'Мы работаем по модели «успех-fee» — оплата только при успешном возврате средств. Комиссия составляет 4-15% от возвращенной суммы в зависимости от сложности дела.'
  }
];

// Mock function to simulate form submission
export const submitContactForm = async (formData) => {
  // Simulate API delay
  await new Promise(resolve => setTimeout(resolve, 1000));
  
  console.log('Form submitted (MOCK):', formData);
  
  // Save to localStorage for demo purposes
  const requests = JSON.parse(localStorage.getItem('capitara_requests') || '[]');
  requests.push({
    ...formData,
    id: Date.now(),
    timestamp: new Date().toISOString()
  });
  localStorage.setItem('capitara_requests', JSON.stringify(requests));
  
  return {
    success: true,
    message: 'Ваша заявка принята! Мы свяжемся с вами в ближайшее время через Telegram.'
  };
};